<script>
import logo from "@/assets/images/seda/logo-s.png";
import sedaFavicon from "@/assets/images/seda/logo-1.png";
import { FormWizard, TabContent } from "vue-form-wizard";

import booth_booking from "@/components/step-projects-exhibition/booth-booking";
import project_info from "@/components/step-projects-exhibition/project-info";

import { swal } from "../../../helpers/handle_error.js";
import AlertError from "@/components/alert_error";
import ProjectModel from "../../../model/step-project-exhibition/project";
import ProjectsExhibitionServices from "../../../services/ProjectsExhibition";
// import VueQRCodeComponent from "vue-qrcode-component";
import html2canvas from "html2canvas";
import unitTestStepProjectsExhibition from "../../../helpers/unit_test_step_projects_exhibition";

export default {
  components: {
    FormWizard,
    TabContent,
    booth_booking,
    project_info,
    AlertError,
    // "qr-code": VueQRCodeComponent,
  },
  data() {
    return {
      //Page errors.
      errors: [],

      logo,
      isPrintedInformation: false,
      fullName: "",
      Id: "",
      date: "",
      qrCodeContent: "",
      showAlert: false,

      previousDocumentTitle: "",
      previousFaviconHref: "",
    };
  },

  methods: {
    handleError(error) {
      this.showAlert = true;
      if (
        error.response &&
        error.response.status === 422 &&
        error.response.data &&
        error.response.data.errors
      ) {
        this.errors = Object.values(error.response.data.errors);
      } else {
        const responseMessage =
          error.response && error.response.data && error.response.data.message;
        this.errors = [
          responseMessage || error.message || "تعذر إرسال الاستمارة إلى الخادم.",
        ];
      }
    },
    resetForm() {
      this.errors = [];
      swal.close();
    },
    async onComplete() {
      swal.loading();

      try {
        const data = new ProjectModel(
          this.$refs["booth_booking"],
          this.$refs["project_info"]
        );
        const response = await ProjectsExhibitionServices.addProject(data.toFormData());
        const result = response.data && response.data.data;

        if (!result || !result.id) {
          throw new Error("لم تصل بيانات تأكيد التسجيل من الخادم.");
        }

        this.fullName = result.fullName;
        this.Id = result.id;
        this.date = result.date;
        this.qrCodeContent = JSON.stringify({
          Id: this.Id,
          fullName: this.fullName,
          date: this.date,
        });

        this.isPrintedInformation = true;
        this.resetForm();
      } catch (error) {
        this.handleError(error);
        swal.close();
      }
    },
    validateStep(name) {
      var refToValidate = this.$refs[name];
      return refToValidate.validate();
    },
    mergePartialModels(model, isValid) {
      if (isValid) {
        // merging each step model into the final model
        this.finalModel = Object.assign({}, this.finalModel, model);
      }
    },
    // print card
    async printThis() {
      const el = this.$refs.printcontent;
      const options = { type: "dataURL" };
      const printCanvas = await html2canvas(el, options);
      const link = document.createElement("a");
      link.setAttribute("download", this.Id + ".jpg");
      link.setAttribute(
        "href",
        printCanvas.toDataURL("image/jpg").replace("image/jpg", "image/octet-stream")
      );
      link.click();
    },
  },
  destroyed() {
    window.removeEventListener("scroll", this.windowScroll);
    document.title = this.previousDocumentTitle;
    const favicon = document.querySelector("link[rel~='icon']");
    if (favicon && this.previousFaviconHref) {
      favicon.href = this.previousFaviconHref;
    }
  },
  mounted() {
    if (process.env.NODE_ENV === "development") {
      this.$nextTick(() => unitTestStepProjectsExhibition(this.$refs));
    }
    this.previousDocumentTitle = document.title;
    document.title = "سيدة العالم";
    const favicon = document.querySelector("link[rel~='icon']");
    if (favicon) {
      this.previousFaviconHref = favicon.href;
      favicon.href = sedaFavicon;
    }
  },
};
</script>

<template>
  <div style="overflow-x: hidden">
    <!-- Features start -->
    <section
      class="section"
      id="features"
      style="min-height: calc(100vh - 163px); padding-top: 40px"
    >
      <AlertError :showDismissibleAlert="showAlert" :errors="errors"></AlertError>

      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <div class="text-center mb-5">
              <a href="/home/index"><h4>سيدة العالم</h4></a>
              <h5>
                <div class="small-title">معرض المشاريع النسائية الوطني 2026</div>
              </h5>
            </div>
          </div>

          <div v-if="isPrintedInformation" class="text-center print-cover">
            <div class="card-print con-print text-center pt-4" ref="printcontent">
              <h5>معرض المشاريع النسائية الوطني 2026</h5>
              <p><strong>الاسم :</strong> {{ fullName }}</p>
              <p><strong>تاريخ التقديم :</strong> {{ date }}</p>
              <p>تم التسجيل بنجاح</p>
              <p><strong>رقم الماستر :</strong> 910458094521</p>
              <p><strong>رقم الهاتف :</strong> 07877158690</p>
              <!-- <qr-code class="qr-code" :text="qrCodeContent"></qr-code>
              <button type="button" class="btn btn-primary mt-3" @click="printThis">
                طباعة التأكيد
              </button> -->
              <hr />
              <div class="">
                <p class="mb-1">مؤسسة سيدة العالم</p>
              </div>
            </div>
          </div>
          <div v-else class="col-lg-12">
            <div class="mb-5">
              <form-wizard
                color="#556ee6"
                error-color="#a94442"
                step-size="xs"
                back-button-text="السابق"
                next-button-text="التالي"
                finish-button-text="ارسال البيانات"
                @on-complete="onComplete"
              >
                <tab-content
                  title="اختيار البوث"
                  icon="mdi mdi-chevron-double-left"
                  :before-change="() => validateStep('booth_booking')"
                >
                  <booth_booking
                    ref="booth_booking"
                    @on-validate="mergePartialModels"
                  ></booth_booking>
                </tab-content>
                <tab-content
                  title="معلومات المشروع"
                  icon="mdi mdi-chevron-double-left"
                  :before-change="() => validateStep('project_info')"
                >
                  <project_info
                    ref="project_info"
                    @on-validate="mergePartialModels"
                  ></project_info>
                </tab-content>

                <tab-content
                  title="ارسال البيانات"
                  icon="mdi mdi-checkbox-marked-circle-outline"
                >
                  <div class="submission-notes" dir="rtl">
                    <div class="submission-notes-heading">
                      <span class="submission-notes-icon">
                        <i class="fas fa-info-circle" aria-hidden="true"></i>
                      </span>
                      <div>
                        <h4>ملاحظات إتمام التسجيل</h4>
                        <p>يرجى مراجعة المعلومات التالية قبل إرسال الطلب.</p>
                      </div>
                    </div>

                    <div class="submission-note">
                      <i class="fas fa-credit-card" aria-hidden="true"></i>
                      <p>
                        لتثبيت الحجز، يُرجى دفع عربون بقيمة
                        <strong>100,000 دينار عراقي</strong> عبر بطاقة الماستر.
                      </p>
                    </div>

                    <div class="payment-details">
                      <div>
                        <span>رقم بطاقة الماستر</span>
                        <strong dir="ltr">910458094521</strong>
                      </div>
                      <div>
                        <span>رقم الهاتف للتواصل</span>
                        <a href="tel:07877158690" dir="ltr">07877158690</a>
                      </div>
                    </div>

                    <div class="submission-reminder">
                      <i class="fas fa-exclamation-circle" aria-hidden="true"></i>
                      <span
                        >اضغط على «إرسال البيانات» لإكمال التسجيل بعد الاطلاع على
                        الملاحظات.</span
                      >
                    </div>
                  </div>
                </tab-content>
              </form-wizard>
            </div>
          </div>
        </div>
        <!-- end row -->
      </div>
      <!-- end container -->
    </section>
    <!-- Features end -->

    <!-- Footer start -->
    <footer class="footer2">
      <div class="container footer-inner">
        <img :src="logo" alt="شعار مؤسسة سيدة العالم" />
        <p>مؤسسة سيدة العالم · مساحة للإبداع وفرص للنمو</p>
        <span>© 2026 جميع الحقوق محفوظة</span>
      </div>
    </footer>
    <!-- <footer class="landing-footer">
      <div class="container">
        <div class="row">
          <div class="col-md-6">
            <img src="@/assets/images/seda/logo.png" alt height="25" />
            <span class="mx-2">سيدة العالم</span>
          </div>
          <div class="col-md-6">
            <p class="mt-1 text-md-end d-sm-block mb-0">
              {{ new Date().getFullYear() }} © جميع الحقوق محفوظة
            </p>
          </div>
        </div>
      </div>
    </footer> -->
    <!-- Footer end -->
  </div>
</template>

<style scoped>
.footer2 {
  padding: 1.3rem 0;
  background: #203746;
  color: rgba(255, 255, 255, 0.75);
}
.footer-inner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
}
.footer2 img {
  width: 110px;
  height: 42px;
  object-fit: contain;
}
.footer2 p,
.footer2 span {
  margin: 0;
  font-size: 0.76rem;
}

.submission-notes {
  max-width: 700px;
  margin: 2rem auto;
  padding: clamp(1.1rem, 3vw, 1.8rem);
  border: 1px solid #dcebed;
  border-radius: 18px;
  background: linear-gradient(145deg, #fff, #f4fbfb);
  box-shadow: 0 12px 32px rgba(43, 105, 113, 0.08);
}

.submission-notes-heading {
  display: flex;
  align-items: center;
  gap: 0.85rem;
  margin-bottom: 1.25rem;
}

.submission-notes-icon {
  display: grid;
  width: 46px;
  height: 46px;
  flex: 0 0 auto;
  place-items: center;
  border-radius: 14px;
  background: rgba(93, 191, 201, 0.14);
  color: #238f9a;
  font-size: 1.2rem;
}

.submission-notes-heading h4 {
  margin: 0;
  color: #2b4653;
  font-size: 1.15rem;
  font-weight: 800;
}

.submission-notes-heading p {
  margin: 0.15rem 0 0;
  color: #74868e;
  font-size: 0.84rem;
}

.submission-note {
  display: flex;
  align-items: flex-start;
  gap: 0.65rem;
  padding: 0.85rem 1rem;
  border: 1px solid #f3dfd1;
  border-radius: 12px;
  background: #fff8f3;
  color: #765943;
}

.submission-note > i {
  margin-top: 0.2rem;
  color: #f08642;
}

.submission-note p {
  margin: 0;
  line-height: 1.9;
}

.submission-note strong {
  color: #c76b32;
  white-space: nowrap;
}

.payment-details {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0.75rem;
  margin-top: 0.8rem;
}

.payment-details > div {
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: 0.2rem;
  padding: 0.8rem 0.9rem;
  border: 1px solid #e6edef;
  border-radius: 11px;
  background: #fff;
}

.payment-details span {
  color: #7d8c94;
  font-size: 0.75rem;
}

.payment-details strong,
.payment-details a {
  color: #238f9a;
  font-size: 1rem;
  font-weight: 800;
  text-decoration: none;
  unicode-bidi: plaintext;
}

.payment-details a:hover {
  color: #f08642;
}

.submission-reminder {
  display: flex;
  align-items: flex-start;
  gap: 0.5rem;
  margin-top: 1rem;
  color: #74868e;
  font-size: 0.8rem;
  line-height: 1.8;
}

.submission-reminder i {
  margin-top: 0.25rem;
  color: #5dbfc9;
}

@media (max-width: 700px) {
  .footer-inner {
    flex-direction: column;
    text-align: center;
  }

  .submission-notes {
    margin: 1rem auto;
    border-radius: 14px;
  }

  .payment-details {
    grid-template-columns: 1fr;
  }
}
</style>
